<template>
  <div class="home-page">
    <Header></Header>
    <div class="chances-top disflex crfff ac">
      <div @click="back">
        <img width="20" src="../../static/images/back.png" class="nav-icon-left" />
        <div>{{ $t('Back') }}</div>
      </div>
    </div>

    <div class="mission-content ac crfff">
      <div class="fs50 mt50">{{ $t('ai_look_title') }}</div>
      <div class="css-1asaykn mt50 makeup-wrap">
        <div class="makeup-section-stack">
          <div class="desc-card">
            <div class="desc-text">{{ $t('ai_look_tip') }}</div>
          </div>

          <div class="upload-card">
            <div class="section-title fs26 fw7">{{ $t('Upload') }}</div>
            <div class="upload-top-row mt15">
              <div class="upload-left">
                <label class="pick-photo-btn">
                  <input accept="image/*" type="file" class="hidden-input" @change="convertToBase64_v2">
                  <img class="pick-photo-icon" src="../../static/images/transparent.png" alt="" />
                  <span>{{ $t('Upload') }}</span>
                </label>
                <div class="upload-hint fs22 cr999 mt10" v-if="!imageBase64">{{ $t('makeup_upload_hint') }}</div>
              </div>
              <div v-if="imageBase64" class="thumb-preview">
                <img :src="imageBase64" alt="preview" />
              </div>
            </div>
            <div class="example-gallery mt18" v-if="exampleImages.length">
              <div class="example-gallery-title">{{ $t('upload_examples') }}</div>
              <div class="example-gallery-list">
                <button
                  v-for="(item, index) in exampleImages"
                  :key="item + '_' + index"
                  class="example-thumb-btn"
                  @click="openExamplePreview(item)"
                >
                  <img :src="item" class="example-thumb-img" alt="example" />
                </button>
              </div>
            </div>
          </div>

          <div class="preset-card">
            <div class="section-title fs26 fw7">{{ $t('look_select_template') }}</div>
            <div class="section-subtitle fs22 mt10">{{ $t('look_choose_category') }}</div>
            <div class="category-tabs mt30">
              <div
                v-for="group in lookGroups"
                :key="group.key"
                class="category-tab"
                :class="{
                  active: selectedCategoryKey === group.key,
                  selected: selectedTemplate && selectedTemplate.categoryKey === group.key
                }"
                @click="openCategoryModal(group.key)"
              >
                <span>{{ $t('look_cat_' + group.key) }}</span>
                <i v-if="selectedTemplate && selectedTemplate.categoryKey === group.key" class="category-selected-dot"></i>
              </div>
            </div>

            <div class="selected-summary mt30">
              <div class="selected-summary-title fs24">{{ $t('look_selected_template') }}</div>
              <div v-if="selectedTemplate" class="selected-chip-list mt18">
                <div class="selected-chip" @click="openCategoryModal(selectedTemplate.categoryKey)">
                  <div class="selected-chip-thumb">
                    <img v-if="selectedTemplate.preview_image" :src="selectedTemplate.preview_image" alt="selected template" />
                  </div>
                  <div class="selected-chip-main">
                    <span class="selected-chip-category">{{ selectedTemplate.categoryTitle }}</span>
                    <span class="selected-chip-name">{{ selectedTemplate.title }}</span>
                    <span class="selected-chip-desc">{{ getTemplateDesc(selectedTemplate) }}</span>
                  </div>
                  <button class="selected-chip-remove" @click.stop="removeSelectedTemplate">×</button>
                </div>
              </div>
              <div v-else class="selected-empty mt18">{{ $t('look_selected_empty') }}</div>
            </div>
          </div>
        </div>

        <div class="ac mt50">
          <button class="generate-btn" :class="{ disabled: !canSubmit }" :disabled="!canSubmit" @click="submitLook">
            <strong>{{ $t('Generate') }}</strong>
          </button>
        </div>

        <div class="flex chances-info-bar mt30" style="justify-content: space-between;">
          <div class="score-badge">
            <span class="fs24">{{ $t('ChancesLeft') }}</span>
            <span class="fs32 fw7 ml10">{{ score }}</span>
          </div>
          <button class="buy-btn" @click="goPurchaseChances">
            <span>{{ $t('BuyChances') }}</span>
            <img src="../../static/images/buy.png" class="buy-icon" >
          </button>
        </div>
      </div>
    </div>

    <Dialog ref="processDialog" :iscloseMask="true" :modalFoot="false" style="min-height: 300px;" title="" type="alert" width="100">
      <div slot="mdBox" class="alert-modal ac">
        <div class="fs33 mt50 ac">{{ processMsg }}</div>
        <div class="alert-actions mt30">
          <button class="button" @click="closeProcessDialog">{{ $t('OK') }}</button>
          <button v-if="processCanGoHistory" class="button history-btn ml20" @click="goHistoryFromDialog">{{ $t('History') }}</button>
        </div>
      </div>
    </Dialog>

    <Dialog ref="resultDialog" :iscloseMask="true" :modalFoot="false" style="min-height: 300px;" title="" type="alert" width="100">
      <div slot="mdBox" class="alert-modal result-modal">
        <div class="result-modal-close" @click="closeResultDialog">×</div>
        <div class="result-modal-tip mt18">{{ $t('downTips1') }}</div>
        <div class="result-modal-image mt20">
          <img v-if="resultPreviewTab === 1" :src="resultGeneratedUrl" alt="generated result" />
          <img v-else :src="resultOriginalUrl" alt="original result" />
        </div>
        <div class="result-modal-tabs mt24">
          <span :class="{ active: resultPreviewTab === 1 }" @click="resultPreviewTab = 1">{{ $t('Result') }}</span>
          <span :class="{ active: resultPreviewTab === 2 }" @click="resultPreviewTab = 2">{{ $t('Original') }}</span>
        </div>
        <div class="result-link-bar mt24">
          <input class="result-link-input" :value="currentResultUrl" disabled type="text">
          <button
            id="copyLookResultLink"
            class="result-copy-btn"
            :data-clipboard-text="currentResultUrl"
            @click="copyResultLink"
          >
            <img src="../../static/images/Copy.png" alt="copy" />
          </button>
        </div>
      </div>
    </Dialog>

    <div v-if="generatingVisible" class="generating-mask">
      <div class="generating-panel">
        <div class="generating-orbit">
          <span class="orbit-ring ring-one"></span>
          <span class="orbit-ring ring-two"></span>
          <span class="orbit-core"></span>
          <span class="orbit-dot dot-one"></span>
          <span class="orbit-dot dot-two"></span>
          <span class="orbit-dot dot-three"></span>
        </div>
        <div class="generating-title mt30">{{ $t('look_generating_title') }}</div>
        <div class="generating-desc mt15">{{ $t('look_generating_desc') }}</div>
        <div class="generating-progress mt20">
          <span>{{ $t('look_generating_wait') }}</span>
          <strong>{{ generatingCountdown }}s</strong>
        </div>
      </div>
    </div>

    <div v-if="showPresetModal" class="preset-modal-mask" @click.self="closePresetDialog">
      <div class="preset-modal-panel">
        <div class="preset-modal-head">
          <div>
            <div class="preset-modal-title">{{ currentModalGroup ? currentModalGroup.title : '' }}</div>
            <div class="preset-modal-tip">{{ $t('look_select_template_tip') }}</div>
          </div>
          <button class="preset-modal-close" @click="closePresetDialog">×</button>
        </div>

        <div class="preset-modal-body">
          <div v-if="modalSubgroups.length" class="subcategory-tabs">
            <div
              v-for="item in modalSubgroups"
              :key="item.key"
              class="subcategory-tab"
              :class="{ active: modalSubgroupKey === item.key }"
              @click="changeModalSubgroup(item.key)"
            >
              <span>{{ $t('look_cat_' + item.key) }}</span>
              <i>{{ item.count }}</i>
            </div>
          </div>

          <div class="preset-grid">
            <div
              v-for="item in currentModalItems"
              :key="item.id"
              class="preset-item"
              :class="{ active: selectedTemplate && selectedTemplate.id === item.id }"
              @click="selectTemplate(item)"
            >
              <div class="preset-image-wrap">
                <img v-if="item.preview_image" :src="item.preview_image" class="preset-image" alt="template" />
                <div class="preset-image-mask"></div>
                <div class="preset-check" v-if="selectedTemplate && selectedTemplate.id === item.id">✓</div>
              </div>
              <div class="preset-content">
                <div class="preset-title">{{ item.title }}</div>
                <div class="preset-desc">{{ getTemplateDesc(item) }}</div>
              </div>
            </div>
          </div>

          <div class="ac mt20" v-if="hasMoreModalItems">
            <button class="more-btn" @click="loadMoreModalPresets">{{ $t('makeup_load_more') }}</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="examplePreviewVisible" class="example-preview-mask" @click.self="closeExamplePreview">
      <div class="example-preview-panel">
        <button class="example-preview-close" @click="closeExamplePreview">×</button>
        <img :src="activeExampleImage" class="example-preview-image" alt="example preview" />
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
import Clipboard from 'clipboard'

export default {
  components: {
    Header,
    Dialog
  },
  data() {
    return {
      imageBase64: null,
      imageTpye: '',
      score: 0,
      processMsg: '',
      processCanGoHistory: false,
      lookGroups: [],
      selectedCategoryKey: '',
      selectedTemplate: null,
      modalCategoryKey: '',
      modalSubgroupKey: 'all',
      modalVisibleCount: 24,
      showPresetModal: false,
      generatingVisible: false,
      generatingTaskId: '',
      generatingCountdown: 60,
      generatingTimer: null,
      generatingCountdownTimer: null,
      resultGeneratedUrl: '',
      resultOriginalUrl: '',
      resultPreviewTab: 1,
      pendingOriginalPreview: '',
      exampleImages: [
        '../../static/images/ai_makeup/temp_1.png',
        '../../static/images/ai_makeup/temp_2.png',
        '../../static/images/ai_makeup/temp_3.png',
      ],
      examplePreviewVisible: false,
      activeExampleImage: '',
    }
  },
  computed: {
    canSubmit() {
      return !!(this.imageBase64 && this.selectedTemplate && this.selectedTemplate.id)
    },
    currentModalGroup() {
      return this.lookGroups.find(item => item.key === this.modalCategoryKey) || null
    },
    modalSubgroups() {
      return this.currentModalGroup && Array.isArray(this.currentModalGroup.subgroups) ? this.currentModalGroup.subgroups : []
    },
    currentModalAllItems() {
      if (!this.currentModalGroup || !Array.isArray(this.currentModalGroup.items)) {
        return []
      }
      if (!this.modalSubgroupKey || this.modalSubgroupKey === 'all') {
        return this.currentModalGroup.items
      }
      return this.currentModalGroup.items.filter(item => item.subgroup_key === this.modalSubgroupKey)
    },
    currentModalItems() {
      return this.currentModalAllItems.slice(0, this.modalVisibleCount)
    },
    hasMoreModalItems() {
      return this.currentModalAllItems.length > this.currentModalItems.length
    },
    currentResultUrl() {
      return this.resultGeneratedUrl
    }
  },
  created() {
    this.getHome()
    this.getLookTemplates()
  },
  beforeDestroy() {
    this.stopGeneratingPolling()
    this.lockBodyScroll(false)
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    getHome() {
      let that = this
      that.$api.get('/api/user/info', null, r => {
        that.$parent.returnCode(r, function () {
          that.score = r.data.score
        })
      })
    },
    normalizeLookGroups(groups) {
      return (Array.isArray(groups) ? groups : []).map(group => {
        const subgroups = Array.isArray(group.subgroups) && group.subgroups.length
          ? group.subgroups
          : [{ key: 'all', title: this.$t('look_cat_all'), count: Array.isArray(group.items) ? group.items.length : 0 }]
        return {
          key: group.key || '',
          title: group.title || '',
          subgroups,
          items: Array.isArray(group.items) ? group.items : []
        }
      })
    },
    getLookTemplates() {
      let that = this
      that.$api.get('/api/you_cam/look_templates', null, r => {
        that.$parent.returnCode(r, function () {
          that.lookGroups = that.normalizeLookGroups(r.data)
          if (!that.selectedCategoryKey && that.lookGroups.length) {
            that.selectedCategoryKey = that.lookGroups[0].key
          }
        })
      })
    },
    convertToBase64_v2(event) {
      let that = this
      const file = event.target.files[0]
      if (!file) return
      const maxSize = 5 * 1024 * 1024
      if (file.size > maxSize) {
        that.$refs.processDialog.showMaskFun()
        that.processMsg = this.$t('pic_size_limit')
        event.target.value = ''
        return
      }
      const reader = new FileReader()
      reader.onload = (e) => {
        const img = new Image()
        img.src = e.target.result
        img.onload = () => {
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')
          const maxWidth = 800
          const maxHeight = 800
          let { width, height } = img
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width
              width = maxWidth
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height
              height = maxHeight
            }
          }
          canvas.width = width
          canvas.height = height
          ctx.drawImage(img, 0, 0, width, height)
          let outputType = file.type.toLowerCase() === 'image/png' ? 'image/jpeg' : file.type
          this.imageBase64 = canvas.toDataURL(outputType, 0.7)
          this.imageTpye = outputType.split('/')[1]
        }
      }
      reader.readAsDataURL(file)
      event.target.value = ''
    },
    submitLook() {
      let that = this
      if (!that.imageBase64) {
        that.$utils.alertText(that.$t('uploadTips'), 100)
        return
      }
      if (!that.selectedTemplate || !that.selectedTemplate.id) {
        that.$utils.alertText(that.$t('look_select_template'), 100)
        return
      }
      let data = {
        image: {
          type: that.imageTpye,
          content: that.imageBase64
        },
        template_id: that.selectedTemplate.id,
        template_title: that.selectedTemplate.title
      }
      that.pendingOriginalPreview = that.imageBase64
      that.$parent.loadModal(true)
      that.$api.post('/api/you_cam/look_vto', data, r => {
        that.$parent.loadModal(false)
        that.getHome()
        if (r.code == 1) {
          const responseData = r.data || {}
          if (responseData.status === true && responseData.url) {
            that.handleGenerateSuccess(responseData.url)
            return
          }
          if (responseData.task_id) {
            that.startGeneratingPolling(responseData.task_id)
            return
          }
          that.processCanGoHistory = false
          that.$refs.processDialog.showMaskFun()
          that.processMsg = r.msg
        } else {
          that.$utils.alertText(r.msg, 50)
        }
      })
    },
    closeProcessDialog() {
      this.processMsg = ''
      this.processCanGoHistory = false
      this.$refs.processDialog.closeMask()
    },
    openResultDialog() {
      this.resultPreviewTab = 1
      this.$refs.resultDialog.showMaskFun()
    },
    closeResultDialog() {
      this.$refs.resultDialog.closeMask()
    },
    copyResultLink() {
      const clipboard = new Clipboard('#copyLookResultLink')
      clipboard.on('success', () => {
        this.$utils.alertText(this.$t('CopySucceeded'))
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        clipboard.destroy()
      })
    },
    getDefaultSubgroupKey(group) {
      if (!group) {
        return 'all'
      }
      const subgroups = Array.isArray(group.subgroups) ? group.subgroups : []
      if (
        this.selectedTemplate &&
        this.selectedTemplate.categoryKey === group.key &&
        this.selectedTemplate.subgroup_key &&
        subgroups.some(item => item.key === this.selectedTemplate.subgroup_key)
      ) {
        return this.selectedTemplate.subgroup_key
      }
      return subgroups.length ? subgroups[0].key : 'all'
    },
    openCategoryModal(categoryKey) {
      this.selectedCategoryKey = categoryKey
      this.modalCategoryKey = categoryKey
      this.modalVisibleCount = 24
      const group = this.lookGroups.find(item => item.key === categoryKey) || null
      this.modalSubgroupKey = this.getDefaultSubgroupKey(group)
      this.showPresetModal = true
      this.syncBodyLock()
    },
    closePresetDialog() {
      this.showPresetModal = false
      this.syncBodyLock()
    },
    openExamplePreview(image) {
      this.activeExampleImage = image
      this.examplePreviewVisible = true
      this.syncBodyLock()
    },
    closeExamplePreview() {
      this.examplePreviewVisible = false
      this.activeExampleImage = ''
      this.syncBodyLock()
    },
    changeModalSubgroup(subgroupKey) {
      this.modalSubgroupKey = subgroupKey
      this.modalVisibleCount = 24
    },
    getTemplateDesc(item) {
      const parts = []
      if (item.subgroup_title && item.subgroup_title !== 'All') {
        parts.push(item.subgroup_title)
      }
      if (item.category_name) {
        parts.push(item.category_name)
      }
      return parts.join(' · ') || item.title
    },
    selectTemplate(item) {
      const group = this.currentModalGroup
      this.selectedTemplate = {
        ...item,
        categoryKey: this.modalCategoryKey,
        categoryTitle: group ? this.$t('look_cat_' + group.key) : '',
      }
      this.selectedCategoryKey = this.modalCategoryKey
      this.closePresetDialog()
    },
    removeSelectedTemplate() {
      this.selectedTemplate = null
    },
    loadMoreModalPresets() {
      this.modalVisibleCount += 24
    },
    lockBodyScroll(locked) {
      document.body.style.overflow = locked ? 'hidden' : ''
    },
    syncBodyLock() {
      this.lockBodyScroll(this.showPresetModal || this.generatingVisible || this.examplePreviewVisible)
    },
    startGeneratingPolling(taskId) {
      this.stopGeneratingPolling()
      this.generatingTaskId = taskId
      this.generatingCountdown = 60
      this.generatingVisible = true
      this.syncBodyLock()
      this.pollGeneratingTask()
      this.generatingTimer = setInterval(() => {
        this.pollGeneratingTask()
      }, 5000)
      this.generatingCountdownTimer = setInterval(() => {
        this.generatingCountdown -= 1
        if (this.generatingCountdown <= 0) {
          this.handleGeneratingTimeout()
        }
      }, 1000)
    },
    stopGeneratingPolling() {
      if (this.generatingTimer) {
        clearInterval(this.generatingTimer)
        this.generatingTimer = null
      }
      if (this.generatingCountdownTimer) {
        clearInterval(this.generatingCountdownTimer)
        this.generatingCountdownTimer = null
      }
      this.generatingTaskId = ''
      this.generatingVisible = false
      this.generatingCountdown = 60
      this.syncBodyLock()
    },
    pollGeneratingTask() {
      let that = this
      if (!that.generatingTaskId) return
      that.$api.post('/api/you_cam/check_process', { task_id: that.generatingTaskId }, r => {
        if (r.code !== 1) {
          return
        }
        const responseData = r.data || {}
        if (responseData.status === 'success' && responseData.url) {
          that.stopGeneratingPolling()
          that.handleGenerateSuccess(responseData.url)
          that.getHome()
          return
        }
        if (responseData.status === 'failed') {
          that.stopGeneratingPolling()
          that.getHome()
          that.processCanGoHistory = false
          that.$refs.processDialog.showMaskFun()
          that.processMsg = that.$t('Generated failed')
        }
      })
    },
    handleGeneratingTimeout() {
      this.stopGeneratingPolling()
      this.processCanGoHistory = true
      this.processMsg = this.$t('look_timeout_tip')
      this.$refs.processDialog.showMaskFun()
    },
    handleGenerateSuccess(url) {
      this.resultGeneratedUrl = url
      this.resultOriginalUrl = this.pendingOriginalPreview || this.imageBase64
      this.imageBase64 = null
      this.imageTpye = ''
      this.selectedTemplate = null
      this.pendingOriginalPreview = ''
      this.openResultDialog()
    },
    goHistoryFromDialog() {
      this.closeProcessDialog()
      this.$router.push({ path: '/history' })
    },
    goPurchaseChances() {
      this.$router.push({ path: '/purchaseChances' })
    }
  }
}
</script>

<style scoped>
.makeup-wrap {
  padding: 0 0.3rem;
  text-align: left;
}
.desc-card,
.upload-card,
.preset-card {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 0.22rem;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.18);
}
.makeup-section-stack {
  display: flex;
  flex-direction: column;
  gap: 0.28rem;
}
.desc-card {
  padding: 0.32rem 0.28rem;
}
.desc-text {
  font-size: 0.26rem;
  line-height: 1.65;
  color: rgba(255, 255, 255, 0.88);
}
.upload-card,
.preset-card {
  padding: 0.34rem 0.28rem;
}
.section-title {
  color: rgba(255, 255, 255, 0.92);
  line-height: 1.35;
}
.section-subtitle {
  color: rgba(255, 255, 255, 0.68);
  line-height: 1.55;
}
.upload-card {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.18rem;
}
.upload-top-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.26rem;
}
.upload-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
}
.pick-photo-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.1rem;
  padding: 0.18rem 0.32rem;
  background: rgba(26, 75, 169, 0.12);
  border: 1px dashed rgba(26, 75, 169, 0.55);
  border-radius: 0.18rem;
  color: #fff;
  font-size: 0.26rem;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.pick-photo-icon {
  width: 0.36rem;
  height: 0.36rem;
}
.hidden-input {
  display: none;
}
.example-gallery-title {
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.22rem;
  line-height: 1.4;
  margin-bottom: 0.18rem;
}
.example-gallery-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.14rem;
  width: 100%;
}
.example-thumb-btn {
  width: 100%;
  aspect-ratio: 0.8 / 1;
  padding: 0;
  border: none;
  border-radius: 0.16rem;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.08);
  box-shadow: 0 0.08rem 0.18rem rgba(0, 0, 0, 0.18);
}
.example-thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.thumb-preview {
  width: 0.96rem;
  height: 0.96rem;
  align-self: center;
  border-radius: 0.14rem;
  overflow: hidden;
  border: 2px solid rgba(26, 75, 169, 0.35);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
  flex-shrink: 0;
}
.thumb-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.preset-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.18rem;
}
.subcategory-tabs {
  display: flex;
  gap: 0.12rem;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 0.2rem;
}
.subcategory-tabs::-webkit-scrollbar {
  display: none;
}
.subcategory-tab {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 0.08rem;
  padding: 0.12rem 0.2rem;
  border-radius: 0.26rem;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.22rem;
}
.subcategory-tab i {
  font-style: normal;
  color: rgba(255, 255, 255, 0.56);
}
.subcategory-tab.active {
  color: #fff;
  border-color: rgba(26, 75, 169, 0.9);
  background: rgba(26, 75, 169, 0.18);
}
.category-tabs {
  display: flex;
  gap: 0.12rem;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 0.02rem;
}
.category-tabs::-webkit-scrollbar {
  display: none;
}
.category-tab {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  padding: 0.14rem 0.24rem;
  border-radius: 0.3rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.82);
  font-size: 0.24rem;
  line-height: 1.2;
  white-space: nowrap;
  -webkit-tap-highlight-color: transparent;
}
.category-tab.active {
  color: #fff;
  border-color: rgba(26, 75, 169, 0.9);
  background: rgba(26, 75, 169, 0.18);
  box-shadow: 0 0 0 1px rgba(26, 75, 169, 0.22);
}
.category-tab.selected {
  border-color: rgba(58, 139, 255, 0.5);
}
.category-selected-dot {
  width: 0.12rem;
  height: 0.12rem;
  border-radius: 50%;
  background: #4da3ff;
  margin-left: 0.1rem;
  flex: 0 0 auto;
}
.selected-summary {
  padding: 0.24rem 0.22rem;
  border-radius: 0.18rem;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
}
.selected-summary-title {
  color: rgba(255, 255, 255, 0.92);
  font-weight: 700;
}
.selected-chip-list {
  display: flex;
  flex-direction: column;
  gap: 0.16rem;
}
.selected-chip {
  display: flex;
  align-items: center;
  gap: 0.16rem;
  padding: 0.18rem;
  border-radius: 0.16rem;
  background: rgba(26, 75, 169, 0.12);
  border: 1px solid rgba(26, 75, 169, 0.24);
}
.selected-chip-thumb {
  width: 0.92rem;
  height: 0.92rem;
  border-radius: 0.14rem;
  overflow: hidden;
  flex: 0 0 auto;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
}
.selected-chip-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.selected-chip-main {
  min-width: 0;
  flex: 1 1 auto;
}
.selected-chip-category {
  display: inline-block;
  padding: 0.04rem 0.12rem;
  border-radius: 0.2rem;
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.86);
  font-size: 0.2rem;
}
.selected-chip-name {
  display: block;
  margin-top: 0.08rem;
  font-size: 0.24rem;
  color: #fff;
  line-height: 1.35;
}
.selected-chip-desc {
  display: block;
  margin-top: 0.06rem;
  font-size: 0.2rem;
  color: rgba(255, 255, 255, 0.68);
  line-height: 1.35;
}
.selected-chip-remove {
  width: 0.46rem;
  height: 0.46rem;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  font-size: 0.28rem;
  line-height: 1;
  flex: 0 0 auto;
}
.selected-empty {
  font-size: 0.24rem;
  color: rgba(255, 255, 255, 0.62);
  line-height: 1.55;
}
.preset-item {
  border-radius: 0.18rem;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  -webkit-tap-highlight-color: transparent;
  overflow: hidden;
}
.preset-item.active {
  border-color: rgba(26, 75, 169, 0.9);
  box-shadow: 0 0 0 2px rgba(26, 75, 169, 0.2);
}
.preset-image-wrap {
  position: relative;
  aspect-ratio: 1 / 1;
  background: rgba(255, 255, 255, 0.06);
}
.preset-image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.preset-image-mask {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 0.8rem;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.72));
}
.preset-content {
  padding: 0.16rem 0.16rem 0.18rem;
}
.preset-title {
  font-size: 0.25rem;
  font-weight: 700;
  color: #fff;
  line-height: 1.35;
}
.preset-desc {
  margin-top: 0.12rem;
  font-size: 0.22rem;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.72);
  min-height: 0.62rem;
}
.preset-swatches {
  position: absolute;
  left: 0.12rem;
  bottom: 0.12rem;
  display: flex;
  align-items: center;
  gap: 0.06rem;
}
.preset-swatch {
  width: 0.18rem;
  height: 0.18rem;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.28);
}
.preset-check {
  position: absolute;
  top: 0.12rem;
  right: 0.12rem;
  width: 0.34rem;
  height: 0.34rem;
  border-radius: 50%;
  background: rgba(26, 75, 169, 0.92);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.22rem;
  font-weight: 700;
}
.generate-btn {
  width: 90%;
  height: 0.9rem;
  background: linear-gradient(135deg, #1A4BA9 0%, #0d2e6e 100%);
  color: #fff;
  border-radius: 0.45rem;
  border: none;
  font-size: 0.32rem;
  font-weight: 700;
  box-shadow: 0 6px 20px rgba(26, 75, 169, 0.4);
  cursor: pointer;
  transition: all 0.3s;
  -webkit-tap-highlight-color: transparent;
}
.generate-btn:active {
  transform: scale(0.96);
  box-shadow: 0 2px 10px rgba(26, 75, 169, 0.4);
}
.generate-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.chances-info-bar {
  display: flex;
  width: 100%;
  margin: 0 auto 0.4rem;
  background: rgba(255, 255, 255, 0.05);
  padding: 0.12rem 0.22rem;
  border-radius: 0.5rem;
  align-items: center;
  gap: 0.14rem;
}
.score-badge {
  display: flex;
  align-items: center;
  color: #fff;
  min-width: 0;
  flex: 1 1 auto;
  white-space: nowrap;
  overflow: hidden;
}
.score-badge span {
  white-space: nowrap;
}
.score-badge span:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
.score-badge .fs24 {
  line-height: 1.35;
  padding: 0.02rem 0;
}
.buy-btn {
  background: #1A4BA9;
  border: none;
  color: #fff;
  padding: 0.12rem 0.24rem;
  border-radius: 0.3rem;
  font-size: 0.24rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(26, 75, 169, 0.3);
  -webkit-tap-highlight-color: transparent;
  flex: 0 1 48%;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
}
.buy-btn span {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.buy-icon {
  width: 0.28rem;
  margin-left: 0.15rem;
  flex: 0 0 auto;
}
.more-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.14rem 0.32rem;
  min-height: 0.64rem;
  border: 1px solid rgba(26, 75, 169, 0.45);
  background: rgba(26, 75, 169, 0.12);
  color: #fff;
  border-radius: 0.32rem;
  font-size: 0.24rem;
  line-height: 1.35;
  white-space: nowrap;
  overflow: visible;
  -webkit-tap-highlight-color: transparent;
}
.alert-actions {
  display: flex;
  justify-content: center;
  align-items: center;
}
.result-modal {
  padding: 0.24rem 0.26rem 0.32rem;
  background: linear-gradient(180deg, rgba(33, 15, 78, 0.98) 0%, rgba(27, 13, 67, 0.98) 100%);
  border: 1px solid rgba(255, 63, 196, 0.72);
  border-radius: 0.2rem;
  box-shadow: 0 18px 46px rgba(0, 0, 0, 0.38);
}
.result-modal-close {
  text-align: right;
  color: #fff;
  font-size: 0.78rem;
  line-height: 1;
  font-weight: 300;
}
.result-modal-title {
  font-size: 0.34rem;
  font-weight: 700;
  color: #fff;
  text-align: center;
}
.result-modal-tip {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  color: rgba(255, 255, 255, 0.92);
  font-size: 0.3rem;
  line-height: 1.5;
  font-weight: 600;
}
.result-modal-image {
  border-radius: 0.22rem;
  overflow: hidden;
  background: transparent;
  width: auto;
  max-width: 82%;
  margin-left: auto;
  margin-right: auto;
}
.result-modal-image img {
  display: block;
  width: auto;
  max-width: 100%;
  max-height: 7.2rem;
  object-fit: contain;
  margin-left: auto;
  margin-right: auto;
}
.result-modal-tabs {
  display: flex;
  justify-content: center;
  gap: 0.18rem;
  margin-top: 20px;
}
.result-modal-tabs span {
  min-width: 1.58rem;
  padding: 0.16rem 0.26rem;
  border-radius: 0.14rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: transparent;
  color: rgba(255, 255, 255, 0.84);
  font-size: 0.24rem;
  font-weight: 700;
  text-align: center;
}
.result-modal-tabs span.active {
  color: #fff;
  border-color: rgba(43, 122, 255, 0.96);
  background: linear-gradient(180deg, #2c8cff 0%, #1565ff 100%);
  box-shadow: 0 8px 18px rgba(21, 101, 255, 0.28);
}
.result-link-bar {
  margin-top: 20px;
  width: 92%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  gap: 0.12rem;
  padding: 0.12rem;
  border-radius: 0.28rem;
  background: rgba(255, 255, 255, 0.06);
}
.result-link-input {
  flex: 1 1 auto;
  min-width: 0;
  height: 0.76rem;
  padding: 0 0.22rem;
  border: none;
  outline: none;
  border-radius: 0.22rem;
  background: rgba(255, 255, 255, 0);
  color: #fff;
  font-size: 0.25rem;
  text-overflow: ellipsis;
}
.result-copy-btn {
  width: 0.82rem;
  height: 0.82rem;
  flex: 0 0 0.82rem;
  border: none;
  border-radius: 0.2rem;
  background: linear-gradient(135deg, #2d8fff 0%, #8b5dff 52%, #ff5ba7 100%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 12px 24px rgba(95, 90, 255, 0.24);
}
.result-copy-btn img {
  width: 0.42rem;
  height: 0.42rem;
}
.history-btn {
  min-width: 1.8rem;
}
.generating-mask {
  position: fixed;
  inset: 0;
  z-index: 1300;
  background:
    radial-gradient(circle at top, rgba(73, 125, 255, 0.16), transparent 42%),
    rgba(5, 9, 22, 0.92);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.36rem;
}
.generating-panel {
  width: 100%;
  max-width: 6.2rem;
  padding: 0.56rem 0.4rem;
  border-radius: 0.28rem;
  background: linear-gradient(180deg, rgba(17, 25, 48, 0.98) 0%, rgba(9, 14, 29, 0.98) 100%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.42);
  text-align: center;
}
.generating-orbit {
  position: relative;
  width: 2.2rem;
  height: 2.2rem;
  margin: 0 auto;
}
.orbit-ring,
.orbit-core,
.orbit-dot {
  position: absolute;
  border-radius: 50%;
}
.orbit-ring {
  inset: 0;
  border: 1px solid rgba(115, 167, 255, 0.24);
}
.ring-one {
  animation: orbitSpin 6s linear infinite;
}
.ring-two {
  inset: 0.22rem;
  border-color: rgba(123, 99, 255, 0.3);
  animation: orbitSpinReverse 4.5s linear infinite;
}
.orbit-core {
  inset: 0.56rem;
  background: radial-gradient(circle, #5f93ff 0%, #254fae 65%, rgba(37, 79, 174, 0.25) 100%);
  box-shadow: 0 0 28px rgba(77, 136, 255, 0.55);
  animation: corePulse 1.8s ease-in-out infinite;
}
.orbit-dot {
  width: 0.2rem;
  height: 0.2rem;
  background: #fff;
  box-shadow: 0 0 14px rgba(255, 255, 255, 0.62);
}
.dot-one {
  top: 0.18rem;
  left: 50%;
  margin-left: -0.1rem;
  animation: floatDot 2.2s ease-in-out infinite;
}
.dot-two {
  right: 0.2rem;
  bottom: 0.42rem;
  width: 0.16rem;
  height: 0.16rem;
  background: #7b63ff;
  animation: floatDot 2.6s ease-in-out infinite 0.3s;
}
.dot-three {
  left: 0.28rem;
  bottom: 0.32rem;
  width: 0.14rem;
  height: 0.14rem;
  background: #4dc7ff;
  animation: floatDot 2.8s ease-in-out infinite 0.5s;
}
.generating-title {
  font-size: 0.38rem;
  color: #fff;
  font-weight: 700;
  line-height: 1.35;
}
.generating-desc {
  font-size: 0.24rem;
  color: rgba(255, 255, 255, 0.72);
  line-height: 1.55;
}
.generating-progress {
  display: inline-flex;
  align-items: center;
  gap: 0.14rem;
  padding: 0.14rem 0.22rem;
  border-radius: 0.32rem;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.23rem;
}
.generating-progress strong {
  color: #fff;
  font-size: 0.28rem;
}
.preset-modal-mask {
  position: fixed;
  inset: 0;
  z-index: 1200;
  background: rgba(7, 11, 24, 0.76);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.28rem;
}
.example-preview-mask {
  position: fixed;
  inset: 0;
  background: rgba(5, 4, 18, 0.92);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.3rem;
  z-index: 1210;
}
.example-preview-panel {
  position: relative;
  width: 100%;
  max-width: 4.8rem;
  padding: 0;
  background: transparent;
  border: none;
  box-shadow: none;
}
.example-preview-close {
  position: absolute;
  top: 0.18rem;
  right: 0.18rem;
  z-index: 2;
  width: 0.52rem;
  height: 0.52rem;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 50%;
  background: rgba(10, 12, 24, 0.72);
  color: #fff;
  font-size: 0.32rem;
  line-height: 1;
  box-shadow: 0 0.08rem 0.18rem rgba(0, 0, 0, 0.26);
}
.example-preview-image {
  width: 100%;
  max-height: 80vh;
  object-fit: contain;
  display: block;
  border-radius: 0;
}
.preset-modal-panel {
  width: 100%;
  max-width: 7rem;
  max-height: 86vh;
  display: flex;
  flex-direction: column;
  border-radius: 0.24rem;
  background: linear-gradient(180deg, rgba(20, 28, 51, 0.98) 0%, rgba(10, 16, 31, 0.98) 100%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 18px 44px rgba(0, 0, 0, 0.38);
  overflow: hidden;
}
.preset-modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.16rem;
  padding: 0.24rem 0.24rem 0.18rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
}
.preset-modal-title {
  font-size: 0.32rem;
  color: #fff;
  font-weight: 700;
}
.preset-modal-body {
  flex: 1 1 auto;
  min-height: 0;
  padding: 0.22rem 0.24rem 0.4rem;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
}
.preset-modal-close {
  width: 0.56rem;
  height: 0.56rem;
  min-width: 0.56rem;
  min-height: 0.56rem;
  flex: 0 0 0.56rem;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  font-size: 0.32rem;
  line-height: 1;
  box-sizing: border-box;
  aspect-ratio: 1 / 1;
  overflow: hidden;
}
.preset-modal-tip {
  margin-top: 0.14rem;
  color: rgba(255, 255, 255, 0.68);
  font-size: 0.22rem;
  line-height: 1.45;
}
@keyframes orbitSpin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes orbitSpinReverse {
  from {
    transform: rotate(360deg);
  }
  to {
    transform: rotate(0deg);
  }
}
@keyframes corePulse {
  0%, 100% {
    transform: scale(0.96);
    box-shadow: 0 0 22px rgba(77, 136, 255, 0.4);
  }
  50% {
    transform: scale(1.04);
    box-shadow: 0 0 34px rgba(77, 136, 255, 0.62);
  }
}
@keyframes floatDot {
  0%, 100% {
    transform: translateY(0);
    opacity: 0.72;
  }
  50% {
    transform: translateY(-0.08rem);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/aiLookVto.vue